import { Action, createReducer, on } from '@ngrx/store';
import { CompanyState } from '@shared/store/company/company.state';
import { getCompanyById, getCompanyByIdFailure, getCompanyByIdSuccess } from './company.actions';

export const companyInitialState: CompanyState = {
  loading: true,
  company: null,
  errors: null,
};

const reducer = createReducer(
  companyInitialState,

  on(getCompanyById, (state) => ({
    ...state,
    loading: true,
  })),

  on(getCompanyByIdSuccess, (state, { company }) => ({
    ...state,
    loading: false,
    company,
  })),

  on(getCompanyByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    errors: error,
  })),
);

export const companyReducer = (state: CompanyState = companyInitialState, action: Action): CompanyState => reducer(state, action);
